module.exports = __webpack_public_path__ + "static/orr-histology-desktop-72110f89a0e4888986c5db3bf8ed82ff.png";